const EXEMPT_PROTOCOLS = ["mailto:", "javascript:"];
const INTERNAL_SITES = ["save-energy-now.org", "youtube.com", "cleancities.org", "litmos.com", "cleancitiessharepoint.org"];

document.addEventListener('click', function(event) {
  const link = event.target.closest('a');
  if (link === null) {
    return;
  }

  let leavingSite = true;

  // Ignore javascript and mailto links.
  if (EXEMPT_PROTOCOLS.includes(link.protocol)) {
    leavingSite = false;
  } else if (!link.hostname) {
    leavingSite = false
  } else if (link.hostname) {
    // Check the simplest, quickest case of the links hostname being the
    // same as the current page's hostname.
    if (link.hostname === window.location.hostname) {
      leavingSite = false;
    } else {
      // Determine the base hostname of the link (eg, just "energy.gov" for
      // "www.afdc.energy.gov").
      const hostnameParts = link.hostname.split(".");
      const baseHostname = `${hostnameParts[hostnameParts.length - 2]}.${hostnameParts[hostnameParts.length - 1]}`.toLowerCase();

      // See if the base hostname is in a whitelist of "internal" sites or if it's a .gov.
      if (INTERNAL_SITES.includes(baseHostname) || baseHostname.endsWith(".gov")) {
        leavingSite = false;
      }
    }
  }

  if (leavingSite) {
    // Allow the warning to be disabled if the
    // "disable-external-link-warning" data attribute element is present.
    if (link.dataset.disableExternalLinkWarning === 'true') {
      leavingSite = false;
    }
  }

  if (leavingSite) {
    const confirmedLeave = confirm("This link will take you to an external web site. We are not responsible for their content.")
    if (!confirmedLeave) {
      event.stopPropagation();
      event.preventDefault();
    }
  }
});
